export interface ConfigThemeFontDefinition {
  src: string;
  family: string;
  weight: string;
  style?: string;
  display?: FontDisplay;
}

// Load all necessary fonts into the web components
// See https://developer.mozilla.org/en-US/docs/Web/API/CSS_Font_Loading_API
export const loadFontsIntoLightDom = async (
  fontDefinitions : ConfigThemeFontDefinition[],
  themeBaseUrl : string,
  onLoadHandler : CallableFunction = () => {},
) : Promise<void> => {
  if (!URL.canParse(themeBaseUrl)) {
    throw new Error(`themeBaseUrl '${themeBaseUrl}' doesn't look like a URL`);
  }

  // Clean up the base url since it already contains the brandId in the URL.
  // https://dev-library.telefonica.de/1 => https://dev-library.telefonica.de/static/1/...
  // https://dev-library.telefonica.de/epos => https://dev-library.telefonica.de/static/epos/...
  const baseUrl = themeBaseUrl.replace(/\/([0-9a-z]+)$/, '/static/$1');

  const fontFaces = fontDefinitions.map((fontDefinition) => {
    const attributes = (({ src, ...rest }) => rest)(fontDefinition);
    return new FontFace(fontDefinition.family, `url(${baseUrl}${fontDefinition.src})`, attributes);
  });

  await Promise.all(fontFaces.map((fontFace) => fontFace.load().then(() => { onLoadHandler(); })));
  fontFaces.forEach((fontFace) => document.fonts.add(fontFace));
};
